import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Descriptions, Modal, QRCode, Space, Typography } from 'antd';
import { date, money } from './format';

/**
 * What to pay for one return and a NBS IPS QR code that fills in the whole
 * payment order in a mobile bank app, BOP included. The code is drawn in the
 * browser from the text the server builds; nothing is sent anywhere.
 */
/** @param {string} [note] - replaces the default note, which speaks of what is still open on a return. */
export default function PaymentSlipModal({ slip, title, note, onClose }) {
  const { t } = useTranslation('taxReturns');
  const copy = (v) => <Typography.Text copyable={{ text: String(v) }}>{v}</Typography.Text>;

  return (
    <Modal open={Boolean(slip)} title={title || t('slip.title')} footer={null} width={680} onCancel={onClose} destroyOnClose>
      {slip && (
        <Space align="start" size="large" wrap>
          <Space direction="vertical" align="center">
            <QRCode value={slip.qr} size={220} errorLevel="M" bordered={false} />
            <span className="text-xs opacity-70" style={{ maxWidth: 220, textAlign: 'center' }}>
              {t('slip.scan')}
            </span>
          </Space>
          <Space direction="vertical" style={{ minWidth: 320 }}>
            <Descriptions size="small" column={1} bordered>
              <Descriptions.Item label={t('slip.payee')}>{slip.payee}</Descriptions.Item>
              <Descriptions.Item label={t('fields.paymentAccount')}>{copy(slip.account)}</Descriptions.Item>
              <Descriptions.Item label={t('fields.amount')}>{copy(money(slip.amount))}</Descriptions.Item>
              <Descriptions.Item label={t('slip.paymentCode')}>{slip.paymentCode}</Descriptions.Item>
              {slip.purpose && <Descriptions.Item label={t('calc.fields.purposeText')}>{slip.purpose}</Descriptions.Item>}
              <Descriptions.Item label={t('slip.model')}>{slip.model}</Descriptions.Item>
              <Descriptions.Item label={t('fields.bop')}>{copy(slip.reference)}</Descriptions.Item>
              <Descriptions.Item label={t('fields.dueDate')}>{date(slip.dueDate)}</Descriptions.Item>
            </Descriptions>
            <Alert type="info" showIcon message={note || t('slip.note')} />
          </Space>
        </Space>
      )}
    </Modal>
  );
}
